import React, { Fragment } from "react";
import { DKInput, INPUT_TYPE,DKIcon } from "deskera-ui-library";
import MaskInputUtil from "./MaskInputUtil";
import ic_visibility from '../../assets/icons/white/ic_visibility.png'
import ic_invisible from "../../assets/icons/white/ic-invisibility_2black.svg"
class MaskInput extends React.Component {
    ref = React.createRef();
    field = null;

    constructor() {
        super();

        this.state = {
            showUnmaskedText: false,
            unmaskedText: null,
            maskedText: null
        }
    }

    componentDidMount() {
        const state = {
            unmaskedText: null,
            maskedText: null
        }

        if (this.props.value) {
            state.unmaskedText = this.props.value;
            state.maskedText = this.getMaskedText(this.props.showMask, this.props.value);
        }

        if (this.ref?.current?.textfieldId) {
            this.field = document.getElementById(this.ref.current.textfieldId);
            if (this.field) {
                this.field.addEventListener("focusout", () => {
                    this.setState({
                        showUnmaskedText: false
                    });
                });
            }

            if (this.props.setRef) {
                this.props.setRef(this.ref);
            }
        }

        this.setState(state);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            unmaskedText: nextProps.value,
            maskedText: this.getMaskedText(nextProps.showMask, nextProps.value)
        });
    }

    getMaskedText(showMask, inputText) {
        return MaskInputUtil.getMaskedText(showMask, inputText, this.props.unmaskLen);
    }

    onChange(value) {
        this.setState({
            unmaskedText: value,
            maskedText: this.getMaskedText(this.props.showMask, value)
        }, () => {
            this.props.onChange(this.state.unmaskedText);
        });
    }

    onFocus() {
        this.setState({
            showUnmaskedText: true
        });
    }

    render() {
        return (
            <div className="row">
                <DKInput
                    ref={this.ref}
                    autoFocus={this.props.autoFocus}
                    title={this.props.title}
                    icon={this.props.icon}
                    type={this.props.type || INPUT_TYPE.TEXT}
                    placeholder={this.props.placeholder}
                    className={this.props.className}
                    direction={this.props.direction}
                    value={this.state.showUnmaskedText ? this.state.unmaskedText : this.state.maskedText}
                    errorMessage={this.props.errorMessage}
                    readOnly={this.props.readOnly}
                    required={this.props.required}
                    invalid={this.props.invalid}
                    tooltip={this.props.tooltip}
                    canValidate={this.props.invalid}
                    onChange={(value) => {
                        this.onChange(value);
                    }}
                    onFocus={() => {
                        this.onFocus();
                    }}
                    validator={(value) => {
                        return (this.props.validator ? this.props.validator(value) : !this.props.invalid);
                    }}
                />
                {this.props.showMaskUnmaskInline && <DKIcon className={` z-index-1 cursor-hand ic-s ${this.props.tooltip ? "mt-xl":"mt-l"} `} style={{ marginLeft: -40, opacity: .7 }}
                    src={this.state.showUnmaskedText ? ic_visibility : ic_invisible}
                    onClick={() => {
                        this.setState((prevState) => ({
                            showUnmaskedText: !prevState.showUnmaskedText
                        }));
                    }}
                />}
            </div>
        );
    }
}

export default MaskInput;
